module.exports = __webpack_public_path__ + "media/images/pic/home/book-waku-waku-fd1b44a66ee3265da5349f7fb32abf9a.webp";